//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './AnalyzesClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetAllAnalysisPresetsForStudyAnalyzesQueryParameters = {
  studyId?: number | null;
};

export type GetAnalysisPresetByIdAnalyzesQueryParameters = {
  id: number;
};

export type GetAllPatientAnalyzesAnalyzesQueryParameters = {
  patientId?: string | null;
  presetId?: number | null | null;
};

export type GetAnalysisByIdAnalyzesQueryParameters = {
  id: number;
};

    
export function createAnalysisPresetUrl(): string {
  let url_ = getBaseUrl() + "/api/analyzes/presets";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createAnalysisPresetMutationKey(): MutationKey {
  return trimArrayEnd([
      'AnalyzesClient',
      'createAnalysisPreset',
    ]);
}

/**
 * Create analysis preset for study
 */
export function useCreateAnalysisPresetMutation<TContext>(options?: Omit<UseMutationOptions<Types.AnalysisPresetDto, unknown, Types.AnalysisPresetCreationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.AnalysisPresetDto, unknown, Types.AnalysisPresetCreationDto, TContext> {
  const key = createAnalysisPresetMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.AnalysisPresetCreationDto) => Client.createAnalysisPreset(dto), {...options, mutationKey: key});
}
  
    
export function getAllAnalysisPresetsForStudyUrl(studyId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/analyzes/presets?";
if (studyId === null)
    throw new Error("The parameter 'studyId' cannot be null.");
else if (studyId !== undefined)
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAllAnalysisPresetsForStudyDefaultOptions: UseQueryOptions<Types.AnalysisPresetDto[], unknown, Types.AnalysisPresetDto[]> = {
  queryFn: __getAllAnalysisPresetsForStudy,
};
export function getGetAllAnalysisPresetsForStudyDefaultOptions(): UseQueryOptions<Types.AnalysisPresetDto[], unknown, Types.AnalysisPresetDto[]> {
  return getAllAnalysisPresetsForStudyDefaultOptions;
};
export function setGetAllAnalysisPresetsForStudyDefaultOptions(options: UseQueryOptions<Types.AnalysisPresetDto[], unknown, Types.AnalysisPresetDto[]>) {
  getAllAnalysisPresetsForStudyDefaultOptions = options;
}

export function getAllAnalysisPresetsForStudyQueryKey(studyId?: number | undefined): QueryKey;
export function getAllAnalysisPresetsForStudyQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId,  } = params[0] as GetAllAnalysisPresetsForStudyAnalyzesQueryParameters;

    return trimArrayEnd([
        'AnalyzesClient',
        'getAllAnalysisPresetsForStudy',
        studyId as any,
      ]);
  } else {
    return trimArrayEnd([
        'AnalyzesClient',
        'getAllAnalysisPresetsForStudy',
        ...params
      ]);
  }
}
function __getAllAnalysisPresetsForStudy(context: QueryFunctionContext) {
  return Client.getAllAnalysisPresetsForStudy(
      context.queryKey[2] as number | undefined    );
}

export function useGetAllAnalysisPresetsForStudyQuery<TSelectData = Types.AnalysisPresetDto[], TError = unknown>(dto: GetAllAnalysisPresetsForStudyAnalyzesQueryParameters, options?: UseQueryOptions<Types.AnalysisPresetDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get all analysis presets for study
 * @param studyId (optional) 
 */
export function useGetAllAnalysisPresetsForStudyQuery<TSelectData = Types.AnalysisPresetDto[], TError = unknown>(studyId?: number | undefined, options?: UseQueryOptions<Types.AnalysisPresetDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAllAnalysisPresetsForStudyQuery<TSelectData = Types.AnalysisPresetDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.AnalysisPresetDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId,  } = params[0] as GetAllAnalysisPresetsForStudyAnalyzesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.AnalysisPresetDto[], TError, TSelectData>({
    queryFn: __getAllAnalysisPresetsForStudy,
    queryKey: getAllAnalysisPresetsForStudyQueryKey(studyId),
    ...getAllAnalysisPresetsForStudyDefaultOptions as unknown as UseQueryOptions<Types.AnalysisPresetDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * Get all analysis presets for study
 * @param studyId (optional) 
 */
export function setGetAllAnalysisPresetsForStudyData(queryClient: QueryClient, updater: (data: Types.AnalysisPresetDto[] | undefined) => Types.AnalysisPresetDto[], studyId?: number | undefined) {
  queryClient.setQueryData(getAllAnalysisPresetsForStudyQueryKey(studyId),
    updater
  );
}

/**
 * Get all analysis presets for study
 * @param studyId (optional) 
 */
export function setGetAllAnalysisPresetsForStudyDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.AnalysisPresetDto[] | undefined) => Types.AnalysisPresetDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function updateAnalysisPresetUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/analyzes/presets/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateAnalysisPresetMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'AnalyzesClient',
      'updateAnalysisPreset',
      id as any,
    ]);
}

/**
 * Update analysis preset for study
 */
export function useUpdateAnalysisPresetMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.AnalysisPresetDto, unknown, Types.AnalysisPresetUpdateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.AnalysisPresetDto, unknown, Types.AnalysisPresetUpdateDto, TContext> {
  const key = updateAnalysisPresetMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.AnalysisPresetUpdateDto) => Client.updateAnalysisPreset(id, dto), {...options, mutationKey: key});
}
  
    
export function deleteAnalysisPresetUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/analyzes/presets/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteAnalysisPresetMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'AnalyzesClient',
      'deleteAnalysisPreset',
      id as any,
    ]);
}

/**
 * Remove analysis by ID
 */
export function useDeleteAnalysisPresetMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteAnalysisPresetMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.deleteAnalysisPreset(id), {...options, mutationKey: key});
}
  
    
export function getAnalysisPresetByIdUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/analyzes/presets/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAnalysisPresetByIdDefaultOptions: UseQueryOptions<Types.AnalysisPresetDto, unknown, Types.AnalysisPresetDto> = {
  queryFn: __getAnalysisPresetById,
};
export function getGetAnalysisPresetByIdDefaultOptions(): UseQueryOptions<Types.AnalysisPresetDto, unknown, Types.AnalysisPresetDto> {
  return getAnalysisPresetByIdDefaultOptions;
};
export function setGetAnalysisPresetByIdDefaultOptions(options: UseQueryOptions<Types.AnalysisPresetDto, unknown, Types.AnalysisPresetDto>) {
  getAnalysisPresetByIdDefaultOptions = options;
}

export function getAnalysisPresetByIdQueryKey(id: number): QueryKey;
export function getAnalysisPresetByIdQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetAnalysisPresetByIdAnalyzesQueryParameters;

    return trimArrayEnd([
        'AnalyzesClient',
        'getAnalysisPresetById',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'AnalyzesClient',
        'getAnalysisPresetById',
        ...params
      ]);
  }
}
function __getAnalysisPresetById(context: QueryFunctionContext) {
  return Client.getAnalysisPresetById(
      context.queryKey[2] as number    );
}

export function useGetAnalysisPresetByIdQuery<TSelectData = Types.AnalysisPresetDto, TError = unknown>(dto: GetAnalysisPresetByIdAnalyzesQueryParameters, options?: UseQueryOptions<Types.AnalysisPresetDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get analysis preset by ID
 */
export function useGetAnalysisPresetByIdQuery<TSelectData = Types.AnalysisPresetDto, TError = unknown>(id: number, options?: UseQueryOptions<Types.AnalysisPresetDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAnalysisPresetByIdQuery<TSelectData = Types.AnalysisPresetDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.AnalysisPresetDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetAnalysisPresetByIdAnalyzesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.AnalysisPresetDto, TError, TSelectData>({
    queryFn: __getAnalysisPresetById,
    queryKey: getAnalysisPresetByIdQueryKey(id),
    ...getAnalysisPresetByIdDefaultOptions as unknown as UseQueryOptions<Types.AnalysisPresetDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Get analysis preset by ID
 */
export function setGetAnalysisPresetByIdData(queryClient: QueryClient, updater: (data: Types.AnalysisPresetDto | undefined) => Types.AnalysisPresetDto, id: number) {
  queryClient.setQueryData(getAnalysisPresetByIdQueryKey(id),
    updater
  );
}

/**
 * Get analysis preset by ID
 */
export function setGetAnalysisPresetByIdDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.AnalysisPresetDto | undefined) => Types.AnalysisPresetDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function createAnalysisUrl(patientId?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/analyzes?";
if (patientId === null)
    throw new Error("The parameter 'patientId' cannot be null.");
else if (patientId !== undefined)
    url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createAnalysisMutationKey(patientId?: string | undefined): MutationKey {
  return trimArrayEnd([
      'AnalyzesClient',
      'createAnalysis',
      patientId as any,
    ]);
}

/**
 * Attach analysis to patient
 * @param patientId (optional) 
 */
export function useCreateAnalysisMutation<TContext>(patientId?: string | undefined, options?: Omit<UseMutationOptions<Types.AnalysisDto, unknown, Types.AnalysisCreationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.AnalysisDto, unknown, Types.AnalysisCreationDto, TContext> {
  const key = createAnalysisMutationKey(patientId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.AnalysisCreationDto) => Client.createAnalysis(dto, patientId), {...options, mutationKey: key});
}
  
    
export function getAllPatientAnalyzesUrl(patientId?: string | undefined, presetId?: number | null | undefined): string {
  let url_ = getBaseUrl() + "/api/analyzes?";
if (patientId === null)
    throw new Error("The parameter 'patientId' cannot be null.");
else if (patientId !== undefined)
    url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
if (presetId !== undefined && presetId !== null)
    url_ += "presetId=" + encodeURIComponent("" + presetId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAllPatientAnalyzesDefaultOptions: UseQueryOptions<Types.AnalysisDto[], unknown, Types.AnalysisDto[]> = {
  queryFn: __getAllPatientAnalyzes,
};
export function getGetAllPatientAnalyzesDefaultOptions(): UseQueryOptions<Types.AnalysisDto[], unknown, Types.AnalysisDto[]> {
  return getAllPatientAnalyzesDefaultOptions;
};
export function setGetAllPatientAnalyzesDefaultOptions(options: UseQueryOptions<Types.AnalysisDto[], unknown, Types.AnalysisDto[]>) {
  getAllPatientAnalyzesDefaultOptions = options;
}

export function getAllPatientAnalyzesQueryKey(dto: GetAllPatientAnalyzesAnalyzesQueryParameters): QueryKey;
export function getAllPatientAnalyzesQueryKey(patientId?: string | undefined, presetId?: number | null | undefined): QueryKey;
export function getAllPatientAnalyzesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { patientId, presetId,  } = params[0] as GetAllPatientAnalyzesAnalyzesQueryParameters;

    return trimArrayEnd([
        'AnalyzesClient',
        'getAllPatientAnalyzes',
        patientId as any,
        presetId as any,
      ]);
  } else {
    return trimArrayEnd([
        'AnalyzesClient',
        'getAllPatientAnalyzes',
        ...params
      ]);
  }
}
function __getAllPatientAnalyzes(context: QueryFunctionContext) {
  return Client.getAllPatientAnalyzes(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as number | null | undefined    );
}

export function useGetAllPatientAnalyzesQuery<TSelectData = Types.AnalysisDto[], TError = unknown>(dto: GetAllPatientAnalyzesAnalyzesQueryParameters, options?: UseQueryOptions<Types.AnalysisDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get all patient's analyzes
 * @param patientId (optional) 
 * @param presetId (optional) 
 */
export function useGetAllPatientAnalyzesQuery<TSelectData = Types.AnalysisDto[], TError = unknown>(patientId?: string | undefined, presetId?: number | null | undefined, options?: UseQueryOptions<Types.AnalysisDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAllPatientAnalyzesQuery<TSelectData = Types.AnalysisDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.AnalysisDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let patientId: any = undefined;
  let presetId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ patientId, presetId,  } = params[0] as GetAllPatientAnalyzesAnalyzesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [patientId, presetId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.AnalysisDto[], TError, TSelectData>({
    queryFn: __getAllPatientAnalyzes,
    queryKey: getAllPatientAnalyzesQueryKey(patientId, presetId),
    ...getAllPatientAnalyzesDefaultOptions as unknown as UseQueryOptions<Types.AnalysisDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * Get all patient's analyzes
 * @param patientId (optional) 
 * @param presetId (optional) 
 */
export function setGetAllPatientAnalyzesData(queryClient: QueryClient, updater: (data: Types.AnalysisDto[] | undefined) => Types.AnalysisDto[], patientId?: string | undefined, presetId?: number | null | undefined) {
  queryClient.setQueryData(getAllPatientAnalyzesQueryKey(patientId, presetId),
    updater
  );
}

/**
 * Get all patient's analyzes
 * @param patientId (optional) 
 * @param presetId (optional) 
 */
export function setGetAllPatientAnalyzesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.AnalysisDto[] | undefined) => Types.AnalysisDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function deleteAnalysisUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/analyzes/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteAnalysisMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'AnalyzesClient',
      'deleteAnalysis',
      id as any,
    ]);
}

/**
 * Remove analysis by ID
 */
export function useDeleteAnalysisMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteAnalysisMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.deleteAnalysis(id), {...options, mutationKey: key});
}
  
    
export function getAnalysisByIdUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/analyzes/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAnalysisByIdDefaultOptions: UseQueryOptions<Types.AnalysisDto, unknown, Types.AnalysisDto> = {
  queryFn: __getAnalysisById,
};
export function getGetAnalysisByIdDefaultOptions(): UseQueryOptions<Types.AnalysisDto, unknown, Types.AnalysisDto> {
  return getAnalysisByIdDefaultOptions;
};
export function setGetAnalysisByIdDefaultOptions(options: UseQueryOptions<Types.AnalysisDto, unknown, Types.AnalysisDto>) {
  getAnalysisByIdDefaultOptions = options;
}

export function getAnalysisByIdQueryKey(id: number): QueryKey;
export function getAnalysisByIdQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetAnalysisByIdAnalyzesQueryParameters;

    return trimArrayEnd([
        'AnalyzesClient',
        'getAnalysisById',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'AnalyzesClient',
        'getAnalysisById',
        ...params
      ]);
  }
}
function __getAnalysisById(context: QueryFunctionContext) {
  return Client.getAnalysisById(
      context.queryKey[2] as number    );
}

export function useGetAnalysisByIdQuery<TSelectData = Types.AnalysisDto, TError = unknown>(dto: GetAnalysisByIdAnalyzesQueryParameters, options?: UseQueryOptions<Types.AnalysisDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get analysis by ID
 */
export function useGetAnalysisByIdQuery<TSelectData = Types.AnalysisDto, TError = unknown>(id: number, options?: UseQueryOptions<Types.AnalysisDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAnalysisByIdQuery<TSelectData = Types.AnalysisDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.AnalysisDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetAnalysisByIdAnalyzesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.AnalysisDto, TError, TSelectData>({
    queryFn: __getAnalysisById,
    queryKey: getAnalysisByIdQueryKey(id),
    ...getAnalysisByIdDefaultOptions as unknown as UseQueryOptions<Types.AnalysisDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Get analysis by ID
 */
export function setGetAnalysisByIdData(queryClient: QueryClient, updater: (data: Types.AnalysisDto | undefined) => Types.AnalysisDto, id: number) {
  queryClient.setQueryData(getAnalysisByIdQueryKey(id),
    updater
  );
}

/**
 * Get analysis by ID
 */
export function setGetAnalysisByIdDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.AnalysisDto | undefined) => Types.AnalysisDto) {
  queryClient.setQueryData(queryKey, updater);
}